export const runValidations = function (validationFunctions) {
  for (var _len = arguments.length, validateParams = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    validateParams[_key - 1] = arguments[_key];
  }
  for (let validate of validationFunctions) {
    if (!validate(...validateParams)) return false;
  }
  return true;
};
export const validateRequired = (value, fieldObj) => {
  value = value.trim();
  if (value.length) {
    fieldObj.setError('');
    return true;
  } else {
    fieldObj.setError(fieldObj.errorRequired);
    return false;
  }
};
export const validateRequiredSelect = (value, fieldObj) => {
  if (value === '-1' || value === -1) {
    fieldObj.setError(fieldObj.errorRequired);
    return false;
  } else {
    fieldObj.setError('');
    return true;
  }
};
export const validateMaxLength = (value, fieldObj) => {
  if (value.length <= fieldObj.maxLength) {
    fieldObj.setError('');
    return true;
  } else {
    fieldObj.setError(fieldObj.errorMaxLength);
    return false;
  }
};
export const validateMinLength = (value, fieldObj) => {
  if (value.length >= fieldObj.minLength) {
    fieldObj.setError('');
    return true;
  } else {
    fieldObj.setError(fieldObj.errorMinLength);
    return false;
  }
};
export const validateRegex = regEx => {
  return (value, fieldObj) => {
    if (regEx.test(value)) {
      fieldObj.setError('');
      return true;
    } else {
      fieldObj.setError(fieldObj.errorValue);
      return false;
    }
  };
};
export const validateRegexInverse = regEx => {
  return (value, fieldObj) => {
    if (!regEx.test(value)) {
      fieldObj.setError('');
      return true;
    } else {
      fieldObj.setError(fieldObj.errorValue);
      return false;
    }
  };
};

// /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
// export const validateAlphanumeric = validateRegex(/^[\u0621-\u064A\u0660-\u06690-9a-zA-Z]+$/);

let alphaNumericRegex = /\`|\~|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\+|\=|\[|\{|\]|\}|\||\\|\'|\<|\,|\.|\>|\?|\/|\""|\;|\:|\s/g;
export const validateEmail = validateRegex(/^.+\@.+\..+$/);
export const validateAlphanumeric = validateRegexInverse(alphaNumericRegex);
export const validatePassword = validateRegex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}/);
export const handleErrors = response => {
  if (!response.ok) {
    const status = response.status;
    if (status === 401) {
      throw Error(`Unauthorized access`);
    } else {
      throw Error(response.statusText);
    }
  }
  return response;
};
export const validateRequiredCheckbox = (value, fieldObj) => {
  const errorsList = [];
  for (const checkbox of fieldObj.checkboxes) {
    if (checkbox.isRequired && checkbox.isRequired === true && checkbox.value === false) {
      errorsList.push(checkbox.errorRequired);
    }
  }
  if (errorsList.length) {
    fieldObj.setError(errorsList.join('[|]'));
    return false;
  } else {
    fieldObj.setError('');
    return true;
  }
};
export const validateLettersOnly = (value, fieldObj) => {
  const lettersOnlyRegex = /^[\p{L}\s]*$/u;
  if (lettersOnlyRegex.test(value)) {
    fieldObj.setError('');
    return true;
  } else {
    fieldObj.setError(fieldObj.errorValue);
    return false;
  }
};
export const validateAlphabetsOnly = (value, fieldObj) => {
  //allow name like anna-maria, o'conor
  const lettersOnlyRegex = /^[\p{L}\s'-]*$/u;
  if (lettersOnlyRegex.test(value)) {
    fieldObj.setError('');
    return true;
  } else {
    fieldObj.setError(fieldObj.errorValue);
    return false;
  }
};
export const validateAlphaNumericAuth = (value, fieldObj) => {
  const forbiddenChars = /[`~!@#$%^&*()_+={}]/g;
  if (!forbiddenChars.test(value)) {
    fieldObj.setError('');
    return true;
  } else {
    fieldObj.setError(fieldObj.errorValue);
    return false;
  }
};
export const validateEmailRegex = (value, fieldObj) => {
  const emailRegex = /^(?!.*\.\.)[a-zA-Z0-9](\.?[a-zA-Z0-9_-])*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/;
  if (emailRegex.test(value)) {
    fieldObj.setError('');
    return true;
  } else {
    fieldObj.setError(fieldObj.errorValue);
    return false;
  }
};
export const validateAlphaNumericUsername = (value, fieldObj) => {
  /**
   * Validates that the value is alphanumeric and doesn't contain any special characters.
   * available special characters are: \.
   */
  const alphaNumericRegex = /\`|\~|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\+|\=|\[|\{|\]|\}|\||\\|\'|\<|\,|\>|\?|\/|\""|\;|\:|\s/g;
  if (!alphaNumericRegex.test(value)) {
    fieldObj.setError('');
    return true;
  } else {
    fieldObj.setError(fieldObj.errorValue);
    return false;
  }
};
export const validatNumericRegex = (value, fieldObj) => {
  const numericRegex = /^\d+$/;
  if (numericRegex.test(value)) {
    fieldObj.setError('');
    return true;
  } else {
    fieldObj.setError(fieldObj.errorValue);
    return false;
  }
};
export const validateLength = (value, fieldObj) => {
  if (value.length === fieldObj.requiredLength) {
    fieldObj.setError('');
    return true;
  } else {
    fieldObj.setError(fieldObj.errorValue);
    return false;
  }
};
export const validateLengthButNotRequired = (value, fieldObj) => {
  if (!value || value.trim() === '') {
    fieldObj.setError('');
    return true;
  }
  const length = value.length;
  if (length < fieldObj.minLength) {
    fieldObj.setError(fieldObj.errorMinLength);
    return false;
  }
  if (length > fieldObj.maxLength) {
    fieldObj.setError(fieldObj.errorMaxLength);
    return false;
  }
  fieldObj.setError('');
  return true;
};
const getAge = birthDate => {
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || m === 0 && today.getDate() < birthDate.getDate()) {
    age--;
  }
  return age;
};
export const validateIsUnder18 = (value, fieldObj) => {
  const birthDate = new Date(value);
  const age = getAge(birthDate);
  if (age < 18) {
    fieldObj.setError(fieldObj.patternInvalidMessage);
    return false;
  }
  fieldObj.setError('');
  return true;
};